import type { CreditTermBreachNotificationDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CreditTermBreachNotificationService {
  apiName = 'Default';
  

  getNotificationHistory = (userId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CreditTermBreachNotificationDto[]>({
      method: 'GET',
      url: `/api/app/credit-term-breach-notification/notification-history/${userId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
